import es from "./es";
import en from "./en";
import de from "./de";
import it from "./it";
import nl from "./nl";
import fr from "./fr";
import ro from "./ro";
import ru from "./ru";
import ar from "./ar";
import zh from "./zh";

const GASTOS = { es, en, de, it, nl, fr, ro, ru, ar, zh };
export default GASTOS;
